import { render, staticRenderFns } from "./RatingWidget.vue?vue&type=template&id=2089c498&scoped=true"
import script from "./RatingWidget.vue?vue&type=script&lang=js"
export * from "./RatingWidget.vue?vue&type=script&lang=js"
import style0 from "./RatingWidget.vue?vue&type=style&index=0&id=2089c498&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2089c498",
  null
  
)

export default component.exports